export const getUsers = (companyName, projectName) => {
    return (dispatch, getState) => {
    (async () => {
      
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/getUsers?companyName='+companyName+'&projectName='+projectName);
      const users = await rawResponse.json();
    
      console.log(users);
      if (users !== undefined) {
        dispatch({ type: 'USERS_RETRIEVED', users});
        //this.setState({"journalLogs" : content});
      }

    })();
    }
}

export const setAdminView = (adminView) => {
  return (dispatch, getState) => {
    dispatch({type: 'ADMIN_VIEW_SET', adminView});
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/userActions.js